import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { observable, runInAction } from 'mobx';
import {
    callFindCustomerCollateralList,
    callReturnCollateralApply,
    getFindBusinessTime,
} from '@api';

const initialState = {
    certificateNumber: '',
    returnComplete: false,
    applyReturnModalVisible: false,
    certModalVisible: false,
    highGradeModalVisible: false,
    userCollateral: [],
    nonHQCollateralList: [],
    isLoading: false,
    transType: '',
    transInfoVisible: true,
    returnSwitchVisible: true,
    highGradeCollateralSwitch: false,
    loadingFailed: false,
    msg: '',
    transFlagModalVisible: false,
    applyDisabled: false,
    TransMsg: '作業中，請稍後再申請！',
};

const api = {
    findCustomerCollateralList: callFindCustomerCollateralList,
    returnCollateralApply: callReturnCollateralApply,
    getBusinessTime: getFindBusinessTime,
};
const ReturnStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getCollateral() {
            const res = await this.findCustomerCollateralList();
            const userCollateral = res.data.items;
            const hqCollateral = res.data.items.filter(
                data => data.hqFlag === 0
            );
            console.log('getCollateral');
            this.assignData({ userCollateral });
        },
        async getCollateralList() {
            runInAction(async () => {
                const res = await this.findCustomerCollateralList();
                const hqCollateral = res.data.items.filter(
                    data => data.hQFlag === 0
                );
                this.nonHQCollateralList = hqCollateral;
                this.userCollateral = res.data.items.map(item => ({
                    ...item,
                    returnQty: 0,
                }));
            });
        },
        async applyReturn(postData) {
            // this.updateData('applyDisabled', true);
            this.updateData('isLoading', true);
            const res = await this.returnCollateralApply(postData);
            const code = parseInt(res.data.code);
            const message = res.data.message;
            if (res) {
                this.updateData('applyDisabled', false);
                this.updateData('isLoading', false);
                this.updateData('returnComplete', true);
                if (code) {
                    this.updateData('loadingFailed', true);
                    this.updateData('msg', message);
                }
            }
        },
        async getReturnBusinessTime() {
            const res = await this.getBusinessTime();
            const transType = res.item.code;
            const highGradeSwitch =
                res.item.switchOptions.HighGradeCollateralSwitch;
            if (parseInt(highGradeSwitch)) {
                if (highGradeSwitch === '1') {
                    this.updateData('highGradeCollateralSwitch', true);
                } else {
                    this.updateData('highGradeCollateralSwitch', false);
                }
            } else {
                this.updateData('highGradeCollateralSwitch', false);
            }
            const returnCollateralSwitchMessage =
                res.item.switchOffMessage.returnCollateralSwitchMessage;
            this.assignData({ transType, returnCollateralSwitchMessage });
            if (transType === 'Y' || transType === '' || transType === 'E4') {
                this.updateData('transInfoVisible', true);
            } else {
                this.updateData('transInfoVisible', false);
            }
            const returnCollateralSwitch =
                res.item.switchOptions.returnCollateralSwitch;
            if (parseInt(returnCollateralSwitch)) {
                this.updateData('returnSwitchVisible', true);
                return parseInt(returnCollateralSwitch);
            } else {
                this.updateData('returnSwitchVisible', false);
                return parseInt(returnCollateralSwitch);
            }
        },
        closeApplyReturnModal() {
            this.applyReturnModalVisible = false;
        },
        closeCertModal() {
            this.certModalVisible = false;
        },
        setCount({ index, value }) {
            this.userCollateral[index].returnQty = value;
        },
        closeTransFlagModal() {
            this.transFlagModalVisible = false;
        },
        closeHighGradeModal() {
            this.highGradeModalVisible = false;
        },
    })); // 3

export default ReturnStore; // 2

// immutable
// mutable
